class EqualHeight {

	constructor(blockEl) {
		this.el = blockEl;
		this.targets = this.el.querySelectorAll('.equal-height-target');
		this.resizeObserver = null;

		this.init();
	}

	async init() {
		await this.updateHeights();
		this.listenForResize();
	}

	async getHeights() {
		let maxHeight = 0;
		this.targets.forEach((target) => {
			const targetHeight = target.offsetHeight;
			if (targetHeight > maxHeight) {
				maxHeight = targetHeight;
			}
		});
		return maxHeight;
	}

	async updateHeights() {
		const maxHeight = await this.getHeights();
		this.targets.forEach((target) => {
			target.style.height = maxHeight + 'px';
		});
	}

	resetHeights() {
		this.targets.forEach((target) => {
			target.style.height = '';
		});
	}

	listenForResize() {
		this.resizeObserver = new ResizeObserver(() => {
			this.resetHeights();
			this.updateHeights();
		});
		this.resizeObserver.observe(this.el);
	}
}

export default EqualHeight;